var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-simple-table", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("Stock")]),
                    _c("th", [_vm._v("Qty")]),
                    _c("th", [_vm._v("Unit")]),
                    _c("th", [_vm._v("Cost")])
                  ])
                ]),
                _c(
                  "tbody",
                  [
                    _vm._l(_vm.items, function(item, index) {
                      return _c("tr", { key: index }, [
                        _c("td", [_vm._v(_vm._s(item.stockId))]),
                        _c("td", [_vm._v(_vm._s(item.quantity))]),
                        _c("td", [_vm._v(_vm._s(item.unit))]),
                        _c("td", { staticClass: "text-right" }, [
                          _vm._v(_vm._s(item.cost.phpFormat()))
                        ])
                      ])
                    }),
                    _c("tr", [
                      _c("th", { attrs: { colspan: "3" } }, [_vm._v("Total")]),
                      _c("td", { staticClass: "text-right" }, [
                        _vm._v(_vm._s(_vm.totalAmount.phpFormat()))
                      ])
                    ])
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }